const BULK_ADD_USERS = 'organization/users/bulk/CREATE'
export const BULK_ADD_USERS_SUCCESS = `${BULK_ADD_USERS}_SUCCESS`
export const BULK_ADD_USERS_ERROR = `${BULK_ADD_USERS}_ERROR`

export const BULK_SET_USER_LIST = 'BULK_SET_USER_LIST'
export const BULK_RESET = 'BULK_RESET'
export const BULK_START_PROCESSING = 'BULK_START_PROCESSING'
export const BULK_FINISHED_PROCESSING = 'BULK_FINISHED_PROCESSING'
